import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";

@Injectable({
  providedIn: 'root'
})
export class ImportadorIfoodService    extends ServerService {

  listeNovosProdutosIfood(link: string, reducao: number, sincronizarPrecos: boolean = false,
                          sincronizarImagens: boolean = false){
    let params: any = {};

    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;

    const idLoja = this.obtenhaIdDaLoja(link)

    return this.obtenha(  String(`/importador/ifood/produtos/${idLoja}/novos`), params)
  }

  listeAdicionaisProdutosIfood(link: string, idsProdutosIfood: string[], reducao: number){
    const idLoja = this.obtenhaIdDaLoja(link)
    return this.facaPost(String(`/importador/ifood/produtos/${idLoja}/adicionais`), {
      idsProdutosIfood: idsProdutosIfood,
      reducao: reducao
    })
  }


  listeNovosProdutosAnotaAi(link: string, reducao: number, sincronizarPrecos: boolean = false,
                          sincronizarImagens: boolean = false){
    let params: any = {};

    if(reducao >= 0) params.reducao = reducao;
    if(sincronizarPrecos) params.precos = true;
    if(sincronizarImagens) params.imagens = true;

    const idLoja = this.obtenhaIdDaLoja(link)


    return this.obtenha(  String(`/importador/anotaai/produtos/${idLoja}/novos`), params)
  }

  obtenhaIdDaLoja(link: string){
    if(link.split('/').length > 0){
      let partes: any = link.split('?')[0].split('/');

      return  partes[partes.length - 1 ];
    }

    return link;

  }

  extraiaSlugLojaAnota(urlStr: string): string | null {
    //    ///https://pedido.anota.ai/loja/BrocaoFastFood?from=site&utm_source=ig&referer=https://l.instagram.com/
    if(urlStr.startsWith('http')){
      try {
        const url = new URL(urlStr);
        const match = url.pathname.match(/^\/loja\/([^\/?#]+)/i);
        return match ? decodeURIComponent(match[1]) : null;
      } catch {
        return null;
      }
    } else {
      return urlStr;
    }

  }


  importeProduto(produto: any){
    return this.facaPost('/importador/produto', produto)
  }

  importe(idEmpresa: number, link: number, reducao: number) {
    return this.salve('/importador/empresa/' + idEmpresa + '/ifood', {link: link, reducao: reducao})
  }

  finalizouImportacao(){
    return this.facaPost('/importador/finalizou', {})
  }

  salveLinkIfod(linkIfood: string){
    return this.facaPost('/importador/catalogo/salveLojaIfood', {linkIfood: linkIfood})
  }

}
